import { render } from "./FacebookIcon.svg?vue&type=template&id=cc1ac27e"
const script = {}
script.render = render

export default script